import { AccountDownloadsHistory } from '@bpm-web-app/components';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface AccountDownloadsProps {
    title: string;
}

export function AccountDownloadsPage({ title }: AccountDownloadsProps) {
    return (
        <AccountDownloadsHistory title={title} />
    );
}

export default AccountDownloadsPage;

export async function getStaticProps() {
    return {
        props: {
            title: 'Download History'
        }
    };
}
